var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.558 3.604c-1.827.548-4.247 1.78-4.293 2.512.152.304.621 1.06 1.279 1.644.822.73 1.553 1.643 2.1 1.643.548 0 .548-.456 2.192-1.004 1.644-.55 3.562-.55 5.16-.001 1.599.547 3.06 1.78 3.79 2.876.731 1.096 1.553 1.735 2.375 1.872.823.137 2.193-.457 2.421-1.005.23-.548.686-1.644.001-2.74-.684-1.095-2.739-4.11-6.072-5.525-3.333-1.416-7.124-.822-8.95-.274z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78 13.422C2.914 13.696 2 14.61 2 15.888c.457 2.192 1.78 2.42 2.42 2.42.64 0 1.37 0 1.644.822.274.822.274 2.786 3.197 5.48s5.252 3.516 6.576 3.744c1.325.229 1.827.411 1.827-.228 0-.64-.046-2.877 0-3.516.046-.64-.183-1.05-.822-1.233-.638-.183-.73-.092-2.785-1.918C12.411 19.997 12 18.749 12 18.307c.853.091 2.814.22 3.836 0 1.279-.274 2.147-1.05 2.284-2.146.137-1.096-.274-2.466-1.69-2.74-1.416-.274-3.927-.274-4.43-.274-.502 0-1.095 0-.456-1.005.64-1.004.64-1.233.457-1.552-.182-.319-1.735-2.191-2.328-2.556-.594-.366-.96-.685-1.507 0-.548.685-1.279 2.009-1.599 2.876-.32.868-.41 1.781-1.004 2.238-.594.457-.913 0-1.781.274z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.996 23.103c-.867.182-1.826.274-1.735 1.507-.075.67-.181 2.22.001 3.06.23 1.05.686 1.05 1.097.913.411-.137 2.557-.457 4.978-1.964 2.42-1.508 4.566-4.796 4.657-5.71.092-.912-.64-2.054-1.872-2.374-1.233-.32-2.146-.228-3.333 1.553-1.188 1.78-2.923 2.83-3.79 3.013z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTko);
export default __webpack_public_path__ + "static/media/TKO.d7c7df312b325d7dc859399c736b77ce.svg";
export { ForwardRef as ReactComponent };